export default function CloseIconAlt(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M16.44,15.13,11.31,10l5.13-5.13a.93.93,0,0,0-1.31-1.31L10,8.69,4.87,3.56a.93.93,0,1,0-1.3,1.32L8.69,10,3.56,15.13a.93.93,0,1,0,1.32,1.3L10,11.31l5.13,5.13a.93.93,0,0,0,1.31-1.31Z" />
    </svg>
  )
}
